import { isEmpty, isFunction } from 'mc-ui-utils';
class pubSub {
    constructor() {
        this.subscribers = {};
        this.pendingMessages = {};
    }
    subscribe(message, cb) {
        const id = performance.now();
        if (isEmpty(this.subscribers[message])) {
            this.subscribers[message] = {};
        }
        this.subscribers[message][id] = cb;
        if (!isEmpty(this.pendingMessages[message])) {
            this.pendingMessages[message].forEach((dat) => {
                cb(dat);
            });
            this.pendingMessages[message] = [];
        }
        return id;
    }
    unsubscribe(message, id) {
        this.subscribers[message][id] = undefined;
    }
    publish(message, data) {
        if (!isEmpty(this.subscribers[message])) {
            Object.values(this.subscribers[message]).forEach((sub) => {
                if (isFunction(sub)) {
                    sub(data);
                }
            });
        }
        else {
            if (isEmpty(this.pendingMessages[message])) {
                this.pendingMessages[message] = [];
            }
            this.pendingMessages[message].push(data);
        }
    }
}
const PubSub = new pubSub();
export default PubSub;
//# sourceMappingURL=pubsub.js.map